import React from "react";
import Joyride from "react-joyride-react-19";
import styled from "styled-components";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
//import { BloxButton } from 'styled_components/Common/BloxButton';

const FeedbackTourStyle = styled.div`
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
  }
`;

export const FeedbackTour = ({ cypressId, id, site, closeTour, module }) => {
  const feedbackId =
    site?.module === "LOGIN" || site?.module === "HOME"
      ? "feedback-image-home"
      : "feedback-image";

  const steps = [
    {
      target: `#${feedbackId}`,
      content:
        "I love feedback! You can tell me anything from any location on the site, including sending our developers a screenshot of the page you are on.",
      locale: { next: "Close" },
      showBackButton: false,
      module,
      showProgress: true,
      disableBeacon: true,
    },
    {
      target: "#start-tour-container-portal",
      content: "Don’t forget I’m here if you need me.",
      locale: { next: "Finish" },
      showProgress: true,
      disableBeacon: true,
      module: "storage",
    },
  ];

  return (
    <FeedbackTourStyle id={id} className="feedback-tour" data-cy={cypressId}>
      <Joyride
        steps={steps}
        continuous={true}
        tooltipComponent={JoyRideToolTip}
        run={true}
        styles={{
          options: {
            zIndex: 5000,
          },
        }}
        module={module}
        callback={closeTour}
        spotlightPadding={5}
        disableScrolling={true}
        disableBeacon={true}
        disableOverlayClose={true}
      />
    </FeedbackTourStyle>
  );
};
